import { Component, OnInit, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Route } from '../../../node_modules/@angular/compiler/src/core';
import { SharedService } from '../services/shared/shared.service';
import { UserService } from '../services/user/user.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { timer } from 'rxjs';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';

declare var $: any;
declare var grecaptcha: any;
declare var window:any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
@Injectable()
export class LoginComponent implements OnInit {

  appVersion: string;
  year: number = new Date().getFullYear();
  public loggedInUserId;
  isPolicyAgreed: Boolean = false;
  showOtpForm: Boolean = false;
  otpkey1 = ''; otpkey2 = ''; otpkey3 = ''; otpkey4 = '';
  contdownInterval: any;
  countdownTimeInSeconds: any;
  timer;
  timeRemainingMinutes;
  timeRemainingSeconds;
  loggedInUserResponseData = null;
  manualCaptcha: boolean = false;
  constructor(public router: Router, public sharedService: SharedService, public userService: UserService, public foruscareService: ForuscareService) {
    this.appVersion = this.foruscareService.APP_VERSION;
  }
  credential = {
    email: '',
    password: ''
  };

  ngOnInit() {
    $(".grecaptcha-badge").css("visibility", "visible");
    this.manualCaptcha = false;
  }
  public getLoginUserId() {
    return this.loggedInUserId;
  }

  public setLoginUserId(userId) {
    this.sharedService.setLoggedInUserId(userId);
  }
  public setLoginUserEmail(email) {
    this.sharedService.setUserEmail(email);
  }

  showManualCaptcha(componentRef: any, credential: any) {
    let captchaElementV2: any = document.getElementById('g-recaptcha-token-v2');
    captchaElementV2.style.display = "flex";
    this.manualCaptcha = true;
    if(window.recaptchaWidgetId){
        grecaptcha.reset(window.recaptchaWidgetId);
    }
    window.recaptchaWidgetId = grecaptcha.enterprise.render('g-recaptcha-token-v2', {
      sitekey: componentRef.foruscareService.getCaptchaV2SiteKey(),
      callback: function (token) {
        console.log("CAPTCHA passed! Token:");
        let credential: any = {};
        credential.username = componentRef.credential.email;
        credential.password = componentRef.credential.password;
        credential.captchaToken = token;
        credential.manualCaptcha = true;
        componentRef.userService.loginWithCaptcha(credential).subscribe((response: any) => {
          if (response.tokenType == "bearer" && response.value != null && response.additionalInformation != null) {
            /*captcha verified. proceed with post login handler */
            componentRef.postLoginHandler(componentRef, response);
          }
          else {
            componentRef.foruscareService.showNotification("Something went wrong !", "danger");
          }
        });
      },
      'expired-callback': function () {
        console.warn('reCAPTCHA expired');
      },
      'error-callback': function () {
        console.error('reCAPTCHA error');
      }
    });
  }

  postLoginHandler(componentRef: any, response: any) {
    componentRef.loggedInUserResponseData = response;
    if (response.tokenType == "bearer" && response.value != null && response.additionalInformation != null) {

      if (response.additionalInformation.roles != null && response.additionalInformation.roles[0].authority == componentRef.foruscareService.ROLE_SUPER_ADMIN) {
        componentRef.setLoginUserEmail(componentRef.credential.email);
        componentRef.loggedInUserId = response.additionalInformation.userId;
        componentRef.sharedService.updateUserInfo(response);
        componentRef.setLoginUserId(componentRef.loggedInUserId);
        componentRef.sharedService.setIsPasswordResetRequired(response.additionalInformation.isPasswordResetRequired);
        if (componentRef.sharedService.getIsPasswordResetRequired()) {
          componentRef.foruscareService.showNotification("Reset your password to continue.", "danger");
          componentRef.router.navigate(['pwdreset/' + componentRef.credential.email]);
          return;
        }
        else if (response.additionalInformation.isLoginOTPRequired) {
          componentRef.showOTPPage();
        }
        else {
          $(".grecaptcha-badge").css("visibility", "hidden");
          componentRef.foruscareService.showNotification("Logged in successfully.", "success");
          //this.sharedService.updateUserInfo(response); // already updated
          componentRef.sharedService.updateAppInfo({ menuFolded: true });
          componentRef.router.navigate(['/accounts']);
        }
      }
      else {
        componentRef.foruscareService.showNotification("Invalid Login Credentials", "danger");
      }
    }
    else {
      if (response.message != null && response.message.toLowerCase().indexOf("user disabled") > -1) {
        componentRef.foruscareService.showNotification('User disabled due to invalid login attempts, please try again after 3 minutes.', "danger");
      }
      else if (response.message.indexOf("trial expired") > -1) {
        componentRef.foruscareService.showNotification('Your trial period has been expired. Please contact admin to upgrade the plan.', "danger");
      }
      else {
        componentRef.foruscareService.showNotification('Incorrect username or password', "danger");
      }
    }
  }

  loginSubmit() {
    /*to handle use case sensitive email */
    this.credential.email = this.credential.email ? this.credential.email.toLowerCase() : this.credential.email;
    if (this.foruscareService.getActiveEnv() == "STGTELEEYE" || this.foruscareService.getActiveEnv() == "LIVE") {
      let componentRef = this;
      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(componentRef.foruscareService.getCaptchaSiteKey(), { action: 'login' }).then(function (token) {
          let captchaElement: any = document.getElementById('g-recaptcha-token');
          if (captchaElement != null) {
            captchaElement.value = token;
          }
          if (token) {
            let credential: any = {};
            credential.username = componentRef.credential.email;
            credential.password = componentRef.credential.password;
            credential.captchaToken = token;
            componentRef.userService.loginWithCaptcha(credential).subscribe((response: any) => {
              if (response.errorCode == 417) {
                /*bot detected. show manual capctha */
                componentRef.showManualCaptcha(componentRef, credential);
              }
              else {
                componentRef.postLoginHandler(componentRef,response);
              }
            });
          }
          else {
            componentRef.foruscareService.showNotification("Invalid captcha !", "danger");
          }
        });
      });
    }
    else {
      this.userService.loginUser(this.credential)
        .subscribe(response => {
          this.loggedInUserResponseData = response;
          if (response.tokenType == "bearer" && response.value != null && response.additionalInformation != null) {

            if (response.additionalInformation.roles != null && response.additionalInformation.roles[0].authority == this.foruscareService.ROLE_SUPER_ADMIN) {
              this.sharedService.setUserEmail(this.credential.email);
              this.loggedInUserId = response.additionalInformation.userId;
              this.sharedService.updateUserInfo(response);
              this.setLoginUserId(this.loggedInUserId);
              this.sharedService.setIsPasswordResetRequired(response.additionalInformation.isPasswordResetRequired);
              if (this.sharedService.getIsPasswordResetRequired()) {
                this.foruscareService.showNotification("Reset your password to continue.", "danger");
                this.router.navigate(['pwdreset/' + this.credential.email]);
                return;
              }
              else if (response.additionalInformation.isLoginOTPRequired) {
                this.showOTPPage();
              }
              else {
                this.foruscareService.showNotification("Logged in successfully.", "success");
                //this.sharedService.updateUserInfo(response); // already updated
                this.sharedService.updateAppInfo({ menuFolded: true });
                this.router.navigate(['/accounts']);
              }
            }
            else {
              this.foruscareService.showNotification("Invalid Login Credentials", "danger");
            }
          }
          else {
            if (response.message != null && response.message.toLowerCase().indexOf("user disabled") > -1) {
              this.foruscareService.showNotification('User disabled due to invalid login attempts, please try again after 3 minutes.', "danger");
            }
            else if (response.message.indexOf("trial expired") > -1) {
              this.foruscareService.showNotification('Your trial period has been expired. Please contact admin to upgrade the plan.', "danger");
            }
            else {
              this.foruscareService.showNotification('Incorrect username or password', "danger");
            }
          }
        });
    }
  }

  showOTPPage() {
    this.showOtpForm = true;
    /*start: timer*/
    var startMinutes = 9;
    var startSecond = 59;
    this.timeRemainingSeconds = startSecond;
    this.timeRemainingMinutes = startMinutes;
    this.contdownInterval = interval(1000);
    this.countdownTimeInSeconds = this.contdownInterval.pipe(take((startMinutes * 60) + startSecond + 2));
    this.countdownTimeInSeconds.subscribe(x => {
      if (this.timeRemainingMinutes == 0 && this.timeRemainingSeconds == 0) { }
      else {
        this.timeRemainingSeconds--;
      }
      if (this.timeRemainingSeconds < 0) {
        this.timeRemainingSeconds = startSecond;
        this.timeRemainingMinutes--;
      }
      else if (this.timeRemainingMinutes == 0 && this.timeRemainingSeconds <= 0) {
        this.timeRemainingMinutes = 0;
        this.timeRemainingSeconds = 0;
      }



      /*this.timeRemainingSeconds = this.timer - x;
      if(this.timeRemainingSeconds>0){
        
        console.log(this.timer +" "+ x);
      }
      else{
        console.log('called');
          if(this.timeRemainingMinutes>0){
            this.timeRemainingSeconds=startSecond;
            this.timer=startSecond;
            this.timeRemainingMinutes--;
            this.customtimer(this.timeRemainingMinutes,startSecond);
          }
          if(this.timeRemainingMinutes==0){
            this.timeRemainingSeconds=0;
            this.timeRemainingMinutes=0;
          }
      }*/
    });
    /*end: timer*/
  }
  optKeyFocus() {
    if (this.otpkey1 == null || this.otpkey1.length == 0) {
      $('#otpkey1').focus();
      return;
    }
    else if (this.otpkey2 == null || this.otpkey2.length == 0) {
      $('#otpkey2').focus();
      return;
    }
    else if (this.otpkey3 == null || this.otpkey3.length == 0) {
      $('#otpkey3').focus();
      return;
    }
    else if (this.otpkey4 == null || this.otpkey4.length == 0) {
      $('#otpkey4').focus();
      return;
    }
  }
  resendOTP() {
    this.userService.resendOTP()
      .subscribe(response => {
        if (response) {
          this.foruscareService.showNotification("OTP sent to your registered email/mobile", "success");
        }
        else {
          this.foruscareService.showNotification("Something went wrong.Please try again!", "danger");
        }
      });
  }
  submitOTP() {
    this.userService.submitOTP(this.otpkey1 + this.otpkey2 + this.otpkey3 + this.otpkey4)
      .subscribe(response => {
        if (response) {
          this.foruscareService.showNotification("Logged in successfully.", "success");
          //this.sharedService.updateUserInfo(response); // already updated
          this.sharedService.updateAppInfo({ menuFolded: true });
          this.router.navigate(['/accounts']);
        }
        else {
          this.foruscareService.showNotification("Inavlid OTP", "danger")
        }

      });
  }
}
